import React, { useState } from "react";
import PropTypes from "prop-types";

const ExperienceItem = ({
    title,
    subtitle,
    date,
    imgSrc,
    subimg1,
    subimg2,
    subimg3,
    subimg4,
    subimg5,
    subimg6,
    description,
    expanded,
    onExpand,
    itemId,
    layoutType,
}) => {
    // Track the current image index for the carousel
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    // Store all images in an array for easy navigation
    const images = [imgSrc, subimg1, subimg2, subimg3,subimg4, subimg5, subimg6].filter(Boolean);
    const numImages = images.length;

    // Function to handle image navigation
    const handleNextImage = (event) => {
        event.stopPropagation(); 
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % numImages);
    };

    const handlePrevImage = (event) => {
        event.stopPropagation(); 
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + numImages) % numImages);
    };

    const handleExpandToggle = (event) => {
        event.stopPropagation(); 
        onExpand(itemId);
    };

    return (
        <div className={`portfolio__data ${expanded ? "portfolio__data-full" : ""}`}>
            {layoutType === "left" ? (
                <>
                    {/* Layout with title on the left */}
                    {!expanded && (<div className="portfolio__data-text">
                        <h3 className="portfolio__title">{title}</h3>
                        <span className="portfolio__subtitle">{subtitle}</span>
                        <div className="portfolio__calender">
                            <i className="uil uil-calendar-alt">{date}</i>
                        </div>
                    </div>)}


                    {/* Conditionally render rounder and line based on expanded state */}
                    {!expanded && (
                        <>
                            <div>
                                <span className="portfolio__rounder"></span>
                                <span className="portfolio__Experienceline"></span>
                            </div>
                        </>
                    )}

                    {/* White area that will trigger expand/collapse */}
                    <div className="portfolio__expandable" onClick={handleExpandToggle}>
                        {/* Expandable Picture and Description */}
                        <div className="portfolio__expandable-card">
                            {/* Image that does not trigger expand/collapse */}

                            {expanded && (<div className="portfolio__data-text">
                                <h3 className="portfolio__title">{title}</h3>
                                <span className="portfolio__subtitle">{subtitle}</span>
                                <div className="portfolio__calender">
                                    <i className="uil uil-calendar-alt">{date}</i>
                                </div>
                            </div>)}

                            <img
                                src={images[currentImageIndex]} // Display current image based on the index
                                alt="Project Thumbnail"
                                className="portfolio__image"
                                style={{ maxHeight: '410px' }} // Limit image height to 410px
                                onClick={(e) => e.stopPropagation()} // Prevent expand/collapse on image click
                            />

                            {/* Dots for image indicators */}
                            {expanded && (
                                <div className="portfolio__dots" onClick={(e) => e.stopPropagation()}>
                                    {images.map((_, index) => (
                                        <span
                                            key={index}
                                            className={`portfolio__dot ${currentImageIndex === index ? "portfolio__dot--active" : ""}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setCurrentImageIndex(index);
                                            }}
                                        ></span>
                                    ))}
                                    {/* Image carousel navigation */}
                                    <button
                                        className="portfolio__arrow portfolio__arrow-left"
                                        onClick={handlePrevImage}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="arrow">
                                            <path fill="currentColor" fill-rule="evenodd" d="M6 0C2.676 0 0 2.676 0 6v14c0 3.324 2.676 6 6 6h14c3.324 0 6-2.676 6-6V6c0-3.324-2.676-6-6-6H6zm9.3 8 .7.66L11.4 13l4.6 4.34-.7.66-5.3-5 5.3-5z"></path>
                                        </svg>
                                    </button>
                                    <button
                                        className="portfolio__arrow portfolio__arrow-right"
                                        onClick={handleNextImage}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="arrow">
                                            <path fill="currentColor" fill-rule="evenodd" d="M6 0C2.676 0 0 2.676 0 6v14c0 3.324 2.676 6 6 6h14c3.324 0 6-2.676 6-6V6c0-3.324-2.676-6-6-6H6zm4.7 8 5.3 5-5.3 5-.7-.66L14.6 13 10 8.66l.7-.66z"></path>
                                        </svg>
                                    </button>
                                </div>
                            )}

                            {/* Expand/Collapse Button */}
                            <p
                                className="portfolio__expand-button"
                                onClick={handleExpandToggle}
                            >
                                {expanded ? "Less" : "More"}{" "}
                                <i className="bx bx-right-arrow-alt contact__button-icon"></i>
                            </p>
                        </div>

                        {expanded && (
                            <div
                                className={`portfolio__expanded-content ${expanded ? "portfolio__expanded-content-full" : ""}`}
                            >
                                {description}
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <>
                    {/* Layout with image on the left */}
                    <div className="portfolio__expandable" onClick={handleExpandToggle}>
                        {/* Expandable Picture and Description */}
                        <div className="portfolio__expandable-card">
                            {/* Image that does not trigger expand/collapse */}

                            {expanded && (<div className="portfolio__data-text">
                                <h3 className="portfolio__title">{title}</h3>
                                <span className="portfolio__subtitle">{subtitle}</span>
                                <div className="portfolio__calender">
                                    <i className="uil uil-calendar-alt">{date}</i>
                                </div>
                            </div>)}
                            <img
                                src={images[currentImageIndex]} // Display current image based on the index
                                alt="Project Thumbnail"
                                className="portfolio__image"
                                style={{ maxHeight: '410px' }} // Limit image height to 410px
                                onClick={(e) => e.stopPropagation()} // Prevent expand/collapse on image click
                            />

                            {/* Dots for image indicators */}
                            {expanded && (
                                <div className="portfolio__dots" onClick={(e) => e.stopPropagation()}>
                                    {images.map((_, index) => (
                                        <span
                                            key={index}
                                            className={`portfolio__dot ${currentImageIndex === index ? "portfolio__dot--active" : ""}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setCurrentImageIndex(index);
                                            }}
                                        ></span>
                                    ))}
                                    {/* Image carousel navigation */}
                                    <button
                                        className="portfolio__arrow portfolio__arrow-left"
                                        onClick={handlePrevImage}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="arrow">
                                            <path fill="currentColor" fill-rule="evenodd" d="M6 0C2.676 0 0 2.676 0 6v14c0 3.324 2.676 6 6 6h14c3.324 0 6-2.676 6-6V6c0-3.324-2.676-6-6-6H6zm9.3 8 .7.66L11.4 13l4.6 4.34-.7.66-5.3-5 5.3-5z"></path>
                                        </svg>
                                    </button>
                                    <button
                                        className="portfolio__arrow portfolio__arrow-right"
                                        onClick={handleNextImage}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" id="arrow">
                                            <path fill="currentColor" fill-rule="evenodd" d="M6 0C2.676 0 0 2.676 0 6v14c0 3.324 2.676 6 6 6h14c3.324 0 6-2.676 6-6V6c0-3.324-2.676-6-6-6H6zm4.7 8 5.3 5-5.3 5-.7-.66L14.6 13 10 8.66l.7-.66z"></path>
                                        </svg>
                                    </button>
                                </div>
                            )}

                            {/* Expand/Collapse Button */}
                            <p
                                className="portfolio__expand-button"
                                onClick={handleExpandToggle}
                            >
                                {expanded ? "Less" : "More"}{" "}
                                <i className="bx bx-right-arrow-alt contact__button-icon"></i>
                            </p>
                        </div>

                        {expanded && (
                            <div
                                className={`portfolio__expanded-content ${expanded ? "portfolio__expanded-content-full" : ""}`}
                            >
                                {description}
                            </div>
                        )}
                    </div>

                    {/* Conditionally render rounder and line based on expanded state */}
                    {!expanded && (
                        <>
                            <div>
                                <span className="portfolio__rounder"></span>
                                <span className="portfolio__Experienceline"></span>
                            </div>
                        </>
                    )}

                    {!expanded && (<div className="portfolio__data-text">
                        <h3 className="portfolio__title">{title}</h3>
                        <span className="portfolio__subtitle">{subtitle}</span>
                        <div className="portfolio__calender">
                            <i className="uil uil-calendar-alt">{date}</i>
                        </div>
                    </div>)}

                </>
            )}
        </div>
    );
};

ExperienceItem.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    imgSrc: PropTypes.string.isRequired,
    description: PropTypes.node.isRequired,
    expanded: PropTypes.bool.isRequired,
    onExpand: PropTypes.func.isRequired,
    itemId: PropTypes.number.isRequired,
    layoutType: PropTypes.oneOf(["left", "right"]).isRequired, // New prop type for layout type
};

export default ExperienceItem;
